module.exports = __webpack_public_path__ + "img/heikin-ashi_normal@2x.e52ba426.svg";